var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowNextBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5355 15.3554L13.3783 7.48244C13.2176 7.30576 12.9579 7.30576 12.7972 7.48244L12.1205 8.2269C11.9598 8.40358 11.9598 8.68935 12.1205 8.86606L18.2967 15.675L12.1205 22.4839C11.9598 22.6606 11.9598 22.9464 12.1205 23.123L12.7972 23.8675C12.9579 24.0442 13.2176 24.0442 13.3783 23.8675L20.5355 15.9945C20.6962 15.8178 20.6962 15.5321 20.5355 15.3554Z",
    fill: "#1752AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNextBlue);
export default __webpack_public_path__ + "static/media/ArrowNextBlue.a3468c436906e017eb610cb42abcd4be.svg";
export { ForwardRef as ReactComponent };